import React, { Component } from 'react';
import { withRouter } from 'react-router';

class Colordiv extends Component {
  render() {
      const {title} = this.props;
    return (
      <div className={`colors-divs ${title === 'yellow' ? 'yellow' : ''} ${title === 'orange' ? 'orange' : ''} ${title === 'purple' ? 'purple' : ''} ${title === 'green' ? 'green' : ''} ${title === 'red' ? 'red' : ''} ${title === 'clear' ? 'clear' : ''}`} onClick={this.props.click} title={title}>{title === 'clear' ? 'Clear' : ( <div></div> )}</div>
    );
  }
}

export default withRouter(Colordiv);



// WEBPACK FOOTER //
// ./src/routes/Paitent/colorDiv.js